module.exports = __webpack_public_path__ + "static/img/ic_certificate_c.84da5d06.png";